import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { reportDetailedNotesTypes } from "redux/reducers/Reports/reportDetailedNotes/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_DETAILED_NOTES_FILTERS } = reportDetailedNotesTypes;

export const getReportDetailedNotesAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    dispatch(startRequestComp('loadingDetailedNotes'));
    try {
      const params = new URLSearchParams({
        idStation: station?.id,
        start: startDate,
        end: endDate,
        pdf: isPdf
      });
      const url = `${process.env.REACT_APP_URL}${PROYECT}/reports/detailed-notes?${params}`;
      const res = await axios.get(url, {
        headers: { authorization: token },
        responseType: "blob"
      });

      saveAs(res.data, `Reporte_Detallado_de_Notas_${station?.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingDetailedNotes'));
    }
  };
};

export const setReportDetailedNotesFilters = (key = "", value) => ({
  type: SET_DETAILED_NOTES_FILTERS,
  payload: { key, value }
});
